import {useSelector} from "react-redux";

import {DetailsPanel, DetailsPanelRow, DetailsPanelSeparator} from "../../component/panels";
import {useRevaTranslation} from "../../hooks/languageHooks";
import {selectValuationMetadata} from "../../redux/persistenceSlice";
import {formatDateAndTime} from "../../util/dateUtil";

export function PanelCorrection() {
    const metadata = useSelector(selectValuationMetadata);
    const {t, language} = useRevaTranslation();

    // Ab der ersten Korrektur liefert der Server Zähler UND Historie; fehlt eines von beiden, gibt es nichts
    // anzuzeigen. Der Check hier erspart das defensive Nachfragen in der gesamten Darstellung.
    const correctionHistory = metadata?.correctionHistory;
    if (!metadata?.correctionCounter || !correctionHistory?.length) {
        return null;
    }
    // Der letzte Eintrag steht schon oben als "letzte Korrektur"; darunter folgen nur die davor.
    const historyLength = correctionHistory.length - 1;

    return (
        <DetailsPanel icon={"pi pi-history"} title={t("order.correction.title")}>
            <DetailsPanelRow label={t("order.correction.counter")} value={metadata.correctionCounter} />
            <DetailsPanelRow
                label={t("order.correction.dateLast")}
                value={formatDateAndTime(metadata.correctionDate, language)}
            />
            <DetailsPanelRow
                label={t("order.correction.user")}
                value={metadata.correctionUserFullName ?? metadata.correctionUser}
            />
            <DetailsPanelRow
                label={t("order.correction.comment")}
                value={correctionHistory[metadata.correctionCounter - 1]?.comment}
            />
            {correctionHistory
                .slice(0, historyLength)
                .reverse()
                .map((correction, index) => (
                    <div key={index}>
                        <DetailsPanelSeparator />
                        <DetailsPanelRow
                            label={t("order.correction.date", {number: historyLength - index})}
                            value={formatDateAndTime(correction.date, language)}
                        />
                        <DetailsPanelRow
                            label={t("order.correction.user")}
                            value={correction.userFullName ?? correction.user}
                        />
                        <DetailsPanelRow label={t("order.correction.comment")} value={correction.comment} />
                    </div>
                ))}
        </DetailsPanel>
    );
}
